module.exports = __webpack_public_path__ + "img/ygr.0ff2de17.png";